/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Partition } from './partition';
import { PartitionValueFilter } from './partitionValueFilter';


export interface BusinessObjectDataPartitions { 
    namespace: string;
    businessObjectDefinitionName: string;
    businessObjectFormatUsage: string;
    businessObjectFormatFileType: string;
    businessObjectFormatVersion?: number;
    partitionValueFilters?: Array<PartitionValueFilter>;
    businessObjectDataVersion?: number;
    /**
     * A Business Object Data Status value specified in the request for available Business Object Data
     */
    businessObjectDataStatus?: string;
    storageNames?: Array<string>;
    partitions?: Array<Partition>;
    asOfTime?: Date;
}
